import { z } from "zod";

const DailyDataSchema = z.object({
    date: z.string().regex(/^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/, {
        message: "Date must be in YYYY-MM-DD format.",
    }),
    room_type_id: z.string().nullable(),
    occupancy: z.string(),
    total_booked: z.number(),
    total_rooms: z.number(),
    available: z.number(),
});

const OccupancyDailyResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(DailyDataSchema),
});

export type OccupancyDailyResponse = z.infer<typeof OccupancyDailyResponseSchema>;
export { OccupancyDailyResponseSchema };